<!-- System Group Selection (Explorer Mode) -->
@if (data()?.isExplorerMode && !selectedSystemGroupName()) {
  <div class="overflow-hidden">
    <div class="mb-4 flex justify-center gap-4 border-b border-gray-100 pb-2">
      <h2 class="flex-1">{{ 'diagnosis.systemGroup.selectTitle' | transloco }}</h2>
      <p-button severity="contrast" icon="pi pi-times" size="small" [aria-label]="'global.close' | transloco" (onClick)="close?.()" />
    </div>
  </div>

  <div class="mt-6">
    <h3 class="text-base">{{ 'diagnosis.systemGroup.choosePrompt' | transloco }}</h3>

    <div class="mt-6">
      @for (systemGroup of availableSystemGroups(); track systemGroup.systemGroupName) {
        <app-item-box (click)="onSystemGroupSelect(systemGroup.systemGroupName)" [isButton]="true" showArrow="right" class="mt-2 w-full">
          <strong class="flex items-center gap-2 font-semibold">
            <span class="capitalize">{{ systemGroup.systemGroupName }}</span>
          </strong>
        </app-item-box>
      }
    </div>
  </div>
} @else {
  <!-- Selected VariantGroup -->
  <div class="overflow-hidden">
    <div class="mb-4 flex justify-center gap-4 border-b border-gray-100 pb-2">
      <h2 class="flex-1" [attr.title]="selectedVariantGroupId()">
        @if (data()?.isExplorerMode && selectedSystemGroupName()) {
          {{ selectedSystemGroupName() }} -
        }
        {{ 'diagnosis.group.title' | transloco }} {{ selectedVariantGroup()?.text }}
      </h2>

    <p-button severity="contrast" icon="pi pi-times" size="small" [attr.aria-label]="'global.close' | transloco" (onClick)="close?.()" />
  </div>
</div>

  <!-- Breadcrumb -->
  <app-breadcrumb [items]="breadcrumbItems()" class="mt-2" />

  <!-- Step-by-step diagnosis (opened component) -->
  @if (selectedComponent()) {
    <app-step-by-step-diagnosis
      [carTypeId]="this.data()?.carTypeId"
      [component]="selectedComponent()"
      (onFinish)="onDiagnosisFinish()"
      (onBackClick)="onBackClick()"
      class="" />
  } @else {
    <!-- Variant / component selection -->
    <!-- available variants per group -->
    <div class="mt-6">
      <h3 class="text-base">{{ 'diagnosis.category.title' | transloco }}</h3>

      <div class="relative mt-6 lg:min-h-24">
        <!-- Skeleton -->
        <div
          class="pointer-events-none absolute left-0 right-0 top-0 flex h-24 flex-col gap-2"
          [ngClass]="{ 'opacity-0': !isLoading(), 'opacity-100': isLoading() }">
          <app-item-box class="pointer-events-none h-1/2" [ngClass]="{ 'animate-pulse': isLoading() }" />
          <app-item-box class="pointer-events-none h-1/2" [ngClass]="{ 'animate-pulse': isLoading() }" />
        </div>

        <div class="relative">
          @if (selectedVariantId()) {
            <app-item-box
              (click)="clearSelectedVariant()"
              [isButton]="true"
              showArrow="left"
              class="mt-2 w-full"
              [attr.title]="selectedVariant()?.system_type_id">
              <span class="font-semibold">{{ selectedVariant()?.text?.trim() }}</span>
            </app-item-box>
          } @else {
            @for (variant of variants(); track variant.system_type_id) {
              <app-item-box (click)="onVariantChange(variant.system_type_id)" [isButton]="true" showArrow="right" class="mt-2 w-full">
                <span class="font-semibold">{{ variant.text?.trim() }}</span>
              </app-item-box>
            }
          }
        </div>
      </div>
    </div>

    <!-- available components per variant -->
    @if (selectedVariantId()) {
      <div class="mt-6">
        <h3 class="text-base">{{ 'diagnosis.component.title' | transloco }}</h3>

        <div class="mt-6">
          @for (component of components(); track component?.symbolInstanceId) {
            <app-item-box
              (click)="openDiagnosis(component)"
              [isButton]="true"
              showArrow="right"
              class="mt-2"
              [attr.title]="component?.symbolInstanceId">
              <div class="flex items-center gap-2 font-semibold">
                @if (finishedComponents().includes(component?.symbolInstanceId ?? 0)) {
                  <i class="pi pi-check-circle text-primary-500"></i>
                } @else {
                  <i class="pi pi-circle"></i>
                }
                <span>{{ `${component?.number ?? ''} ${component?.name ?? ''}`.trim() }}</span>
              </div>
            </app-item-box>
          }
        </div>
      </div>

      @if (!isLoading() && components()?.length === 0) {
        <div class="mt-4 italic">{{ 'diagnosis.notAvailable' | transloco }}</div>
      }
    }
  }
}
